<script>
  let className = "";
  export let fixed;

  export { className as class };
</script>

<div class={className} style="margin: 0 -32px">
  <div class="w-full sm:hidden -z-1">
    <slot name="sm" />
  </div>
  <div class="w-full hidden sm:block -z-1" class:fixed={fixed} class:left-0={fixed} class:bottom-0={fixed}>
    <slot name="md" />
  </div>
</div>
